// src/pages/AccountDisabledPage.js
import React from "react";
import { useLocation } from "react-router-dom";

export default function AccountDisabledPage() {
  const { state } = useLocation();
  return (
    <div style={{ padding: 24 }}>
      <h2>Account Disabled</h2>
      <p>{state?.error || "Your account has been disabled."}</p>
    </div>
  );
}
